export default "__VITE_ASSET__Cni$GURj__"